import React, { useState, useEffect } from 'react';

const TeamForm = ({ onAddMember, onSaveEdit, onCancelEdit, editingMember }) => {
  const [formData, setFormData] = useState({
    name: '',
    startDate: new Date().toISOString().split('T')[0],
    salary: '',
    paymentDay: '15',
    bonusPercentage: '0',
    pixKey: ''
  });
  
  // Quando estiver editando um membro, preencher o formulário com os dados dele
  useEffect(() => {
    if (editingMember) {
      setFormData({
        name: editingMember.name || '',
        startDate: editingMember.startDate || new Date().toISOString().split('T')[0],
        salary: editingMember.salary || '',
        paymentDay: editingMember.paymentDay || '15',
        bonusPercentage: editingMember.bonusPercentage || '0',
        pixKey: editingMember.pixKey || ''
      });
    } else {
      // Resetar formulário quando não estiver editando
      setFormData({
        name: '',
        startDate: new Date().toISOString().split('T')[0],
        salary: '',
        paymentDay: '15',
        bonusPercentage: '0',
        pixKey: ''
      });
    }
  }, [editingMember]);
  
  // Lidar com mudanças nos campos do formulário
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  // Enviar formulário
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validação básica
    if (!formData.name || !formData.startDate || !formData.salary) {
      alert('Por favor, preencha pelo menos o nome, a data de início e o salário!');
      return;
    }
    
    // Formatar os dados para garantir que sejam do tipo correto
    const formattedData = {
      ...formData,
      salary: parseFloat(formData.salary) || 0,
      bonusPercentage: parseFloat(formData.bonusPercentage) || 0
    };
    
    // Se estiver editando, salvar edição, senão adicionar novo membro
    if (editingMember) {
      onSaveEdit(formattedData);
    } else {
      onAddMember(formattedData);
    }
    
    // Limpar formulário
    setFormData({
      name: '',
      startDate: new Date().toISOString().split('T')[0],
      salary: '',
      paymentDay: '15',
      bonusPercentage: '0',
      pixKey: ''
    });
  };
  
  return (
    <form className="team-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="name">Nome</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Nome completo"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="startDate">Data de Início</label>
          <input
            type="date"
            id="startDate"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="salary">Salário (R$)</label>
          <input
            type="number"
            id="salary"
            name="salary"
            value={formData.salary}
            onChange={handleChange}
            placeholder="0.00"
            step="0.01"
            min="0"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="paymentDay">Dia de Pagamento</label>
          <input
            type="number"
            id="paymentDay"
            name="paymentDay"
            value={formData.paymentDay}
            onChange={handleChange}
            placeholder="Dia do mês (1-31)"
            min="1"
            max="31"
            required
          />
        </div>
      </div>
      
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="bonusPercentage">Bônus (%)</label>
          <input
            type="number"
            id="bonusPercentage"
            name="bonusPercentage"
            value={formData.bonusPercentage}
            onChange={handleChange}
            placeholder="0"
            min="0"
            max="100"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="pixKey">Chave PIX</label>
          <input
            type="text"
            id="pixKey"
            name="pixKey"
            value={formData.pixKey}
            onChange={handleChange}
            placeholder="CPF, e-mail, telefone ou chave aleatória"
          />
        </div>
      </div>
      
      <div className="form-actions">
        {editingMember ? (
          <>
            <button type="submit" className="btn-primary">Salvar Alterações</button>
            <button type="button" className="btn-secondary" onClick={onCancelEdit}>Cancelar</button>
          </>
        ) : (
          <button type="submit" className="btn-primary">Adicionar Colaborador</button>
        )}
      </div>
    </form>
  );
};

export default TeamForm;